//import { toTestId } from '@panwds/react-utils'
import { classNames, tw, twMerge } from '@panwds/tailwindcss';
import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react';
import { getBackgroundClass, getBorderClass, getCursorClass, getLabelCursorClass, getLabelTextColorClass, getOutlineClass, getRingClass, getRoundedClass, getTextColorClass } from './checkbox.logic.js';
import { toTestId } from '@panwds/react-utils';
// checkbox Classes
const defaultClass = tw `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-m-0 tw-font-lato tw-leading-4 tw-font-black tw-form-checkbox`;
//label classes
const labelDefaultClass = tw `tw-flex tw-text-xs tw-font-normal tw-leading-5 tw-font-lato tw-items-center tw-space-x-2`;
/**
 * Lets users toggle a boolean value.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { Checkbox } from "@panwds/react-ui";
 * ```
 */
export const Checkbox = forwardRef(({ addClassName = '', checked, dataMetrics, dataTestId, disabled = false, indeterminate, isError, onChange, readOnly = false, children, ...passThrough }, incomingRef) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const defaultRef = useRef(null);
    const useableRef = incomingRef ?? defaultRef;
    const id = dataTestId || children ? `checkbox-${typeof children === 'string' && toTestId(children)}` : 'checkbox';
    useLayoutEffect(() => {
        if (useableRef?.current && checked !== undefined)
            useableRef.current.checked = checked;
        if (useableRef?.current && indeterminate !== undefined)
            useableRef.current.indeterminate = indeterminate;
    }, [checked, indeterminate]);
    const labelClasses = classNames(labelDefaultClass, getLabelTextColorClass({ disabled }), getLabelCursorClass({ disabled, readOnly }));
    const checkboxClasses = twMerge(defaultClass, getTextColorClass({ disabled, isError, readOnly }), getBackgroundClass({ disabled, isError, readOnly, checked, indeterminate }), getBorderClass({ disabled, isError, readOnly }), getRoundedClass({ isFocused, isHovered }), getRingClass({ isFocused, isHovered }), getCursorClass({ disabled, readOnly }), getOutlineClass({ isHovered, isFocused, disabled, readOnly }), addClassName);
    const handleFocus = () => {
        setIsFocused(true);
    };
    const handleBlur = () => {
        setIsFocused(false);
    };
    const handleMouseOver = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    return (React.createElement("label", { className: labelClasses },
        React.createElement("input", { "data-metrics": `input-checkbox-${dataMetrics}`, "data-testid": `input-checkbox-${id}`, "aria-checked": indeterminate ? 'mixed' : checked, checked: checked, disabled: disabled || readOnly, onChange: onChange, ref: useableRef, readOnly: readOnly, type: "checkbox", onFocus: handleFocus, onBlur: handleBlur, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave, className: checkboxClasses, ...passThrough }),
        children && React.createElement("span", { className: labelClasses }, children)));
});
Checkbox.displayName = 'Checkbox';
//# sourceMappingURL=Checkbox.js.map